import { useEffect } from 'react';
import { useThemeStore } from '../../store';

function ThemeProvider({ children }) {
  const { theme } = useThemeStore();

  useEffect(() => {
    // Apply theme to document root
    document.documentElement.setAttribute('data-theme', theme);

    // Update meta theme-color for mobile browsers
    const metaThemeColor = document.querySelector('meta[name="theme-color"]');
    if (metaThemeColor) {
      metaThemeColor.setAttribute(
        'content',
        theme === 'light' ? '#ffffff' : '#0a0a0f'
      );
    }
  }, [theme]);

  return children;
}

export default ThemeProvider;
